import axios from 'axios';
import { getApiBase } from './apiBase';

const API = getApiBase();

/** Fetch vault document bytes with auth (no public URL). */
export async function fetchVaultDocumentBlob(documentId, { preview = false } = {}) {
  const path = preview
    ? `${API}/documents/${documentId}/preview`
    : `${API}/documents/${documentId}/file`;
  const res = await axios.get(path, { responseType: 'blob' });
  return res.data;
}

export async function downloadVaultDocument(documentId, filename) {
  const blob = await fetchVaultDocumentBlob(documentId, { preview: false });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'document';
  a.click();
  window.URL.revokeObjectURL(url);
}

export async function createVaultPreviewUrl(documentId, mimeType) {
  const blob = await fetchVaultDocumentBlob(documentId, { preview: true });
  const typed = mimeType ? new Blob([blob], { type: mimeType }) : blob;
  return window.URL.createObjectURL(typed);
}

export const VAULT_CATEGORIES = [
  { id: 'will', label: 'Will document' },
  { id: 'legal', label: 'Legal document' },
  { id: 'letter', label: 'Letter' },
  { id: 'certificate', label: 'Certificate' },
  { id: 'photo_document', label: 'Photo document' },
  { id: 'other', label: 'Other' },
];

export const WILL_HELPER_TEXT =
  'Store a copy of your will document here for private safekeeping. This is secure storage only — not legal advice and not will creation.';

export const VAULT_DISCLAIMER =
  'MyLegacyBridge provides private storage for your documents. We do not offer legal advice, will drafting, or estate planning services.';

export const VAULT_ACCEPTED_HINT =
  'PDF, Word (.doc/.docx), text, and common image formats · up to 15 MB';

export function isVaultPreviewable(doc) {
  return Boolean(doc?.preview_available);
}

export function formatVaultUploadedDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '—';
  }
}
